var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30V26H26V30H22ZM20 12H28V8H20V12ZM8 42C6.9 42 5.95833 41.6083 5.175 40.825C4.39167 40.0417 4 39.1 4 38V30H18V32C18 32.5667 18.1917 33.0417 18.575 33.425C18.9583 33.8083 19.4333 34 20 34H28C28.5667 34 29.0417 33.8083 29.425 33.425C29.8083 33.0417 30 32.5667 30 32V30H44V38C44 39.1 43.6083 40.0417 42.825 40.825C42.0417 41.6083 41.1 42 40 42H8ZM4 26V16C4 14.9 4.39167 13.9583 5.175 13.175C5.95833 12.3917 6.9 12 8 12H16V8C16 6.9 16.3917 5.95833 17.175 5.175C17.9583 4.39167 18.9 4 20 4H28C29.1 4 30.0417 4.39167 30.825 5.175C31.6083 5.95833 32 6.9 32 8V12H40C41.1 12 42.0417 12.3917 42.825 13.175C43.6083 13.9583 44 14.9 44 16V26H30V24C30 23.4333 29.8083 22.9583 29.425 22.575C29.0417 22.1917 28.5667 22 28 22H20C19.4333 22 18.9583 22.1917 18.575 22.575C18.1917 22.9583 18 23.4333 18 24V26H4Z",
    fill: "url(#paint0_linear_4247_1352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4247_1352",
    x1: 7.91304,
    y1: 41.6832,
    x2: 35.2917,
    y2: 22.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.f183417e3c2495e0da2e01490357915f.svg";
export { ForwardRef as ReactComponent };